import React, { useState } from "react";
import { Theme } from "../../theme";
import Topbar from "./Components/Topbar";
import useTheme from "@material-ui/styles/useTheme";
import styled, { css } from "styled-components";
import Sidebar from "./Components/Sidebar";
import {
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@material-ui/core";

import DashboardIcon from "@material-ui/icons/Dashboard";
import SettingsIcon from "@material-ui/icons/Settings";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import clsx from "clsx";
import MapView from "./Views/MapView";
import CamerasView3 from "./Views/Cameras/CamerasView3";
import CameraContainer from "./Cameras/CameraContainer";
import { useCameras, CameraHook } from "../../hooks/useCameras";
import CamerasView from "./Views/Camerasv2/CamerasView";
import useInterval from "../../hooks/useInterval";

const REFETCH_INTERVAL = 15 * 1000; //15s

const StyledSection = styled.section`
  width: 100vw;
  height: 100vh;
  overflow: hidden;

  ${({ theme }: { theme: Theme }) => {
    return css`
      .shiftContent {
        padding-left: 240px;
      }
      .content {
        /* padding: ${theme.spacing(4)}px; */
        padding-top: 12px;
        height: calc(100vh - 40px);
        overflow-y: auto;
      }
    `;
  }};
`;

const PAGES = [
  {
    title: "Dashboard",
    href: "/dashboard",
    icon: <DashboardIcon />,
  },

  // {
  //   title: "Cameras",
  //   href: "/cameras",
  //   icon: <AccountBoxIcon />,
  // },
  // {
  //   title: "Settings",
  //   href: "/settings",
  //   icon: <SettingsIcon />,
  // },
  // {
  //   title: "Cameras",
  //   href: "/testing",
  //   icon: <SettingsIcon />,
  // },
  {
    title: "Cameras",
    href: "/camerasv2",
    icon: <AccountBoxIcon />,
  },
];

const userDetails = {
  name: "Test User",
  avatar: "",
  bio: "DCM Client 0",
};

const TENANT_ID = "00000000-0000-0000-0000-000000000000";

export interface DashboardContainerProps {
  setAuth: (authed: boolean) => void;
  view: string;
}

const DashboardContainer: React.FC<DashboardContainerProps> = props => {
  const { view } = props;
  const theme: Theme = useTheme();
  const [notifs, setNotifs] = useState<string[]>([]);
  const [openSidebar, setOpenSidebar] = useState(false);
  const [openLogout, setOpenLogout] = useState(false);

  //Camera hook v2 logic
  const cameraHook: CameraHook = useCameras(TENANT_ID);

  //Handle the live data refetch logic
  useInterval(() => {
    cameraHook.methods.fetchMoreData();
  }, REFETCH_INTERVAL);

  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"), {
    defaultMatches: true,
  });

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  //For logout Alert
  function handleLogoutOpen() {
    setOpenLogout(true);
  }
  function handleCancel() {
    setOpenLogout(false);
  }
  function handleOk() {
    setOpenLogout(false);
    props.setAuth(false);
  }

  const shouldOpenSidebar = isDesktop ? true : openSidebar;

  return (
    <>
      <StyledSection theme={theme}>
        <div
          className={clsx({
            ["root"]: true,
            ["shiftContent"]: isDesktop,
          })}
        >
          <Topbar
            notifs={notifs}
            onSidebarOpen={handleSidebarOpen}
            onLogoutOpen={handleLogoutOpen}
            style={{ backgroundColor: theme.palette.primary }}
          />
          <Sidebar
            pages={PAGES}
            onLogoutOpen={handleLogoutOpen}
            userDetails={userDetails}
            onClose={handleSidebarClose}
            open={shouldOpenSidebar}
            variant={isDesktop ? "persistent" : "temporary"}
          />
          <main className="content">
            {/* {view === "cameras" && <CamerasView3 />} */}
            {view === "dashboard" && <MapView />}
            {view === "testing" && <CameraContainer />}
            {view === "camerasv2" && <CamerasView cameraHook={cameraHook} />}
          </main>
          {/* LOGOUT ALERT HERE */}
          <Dialog
            maxWidth="xs"
            open={openLogout}
            onClose={handleCancel}
            aria-labelledby="logout-box"
          >
            <DialogTitle style={{ cursor: "move" }}>Logout</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are you sure you want to logout?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCancel} color="secondary">
                Cancel
              </Button>
              <Button onClick={handleOk} color="primary">
                Logout
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </StyledSection>
    </>
  );
};

export default DashboardContainer;
